// @ts-nocheck
import React, { useEffect, useState } from "react";
import {
  email_icon,
  eye_icon,
  knf_logo,
  logo,
  password_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { isValidEmail } from "../redux/api/Constants";
import { useDispatch } from "react-redux";
import { useLoginMutation } from "../redux/api/api";
import { toast } from "react-toastify";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";

const Login = () => {
  const navigate = useNavigate();

  const [loginApi] = useLoginMutation();
  const [formState, setFormState] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [visible, setVisible] = useState(false);

  const [passwords, setPassword] = useState();
  const [emailId, setEmailId] = useState();

  const { username, password } = formState;
  const { emailErr, passErr } = errors;

  const validatePassword = (password) => {
    return password.length >= 4;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
    if (name === "username") {
      setErrors((prev) => ({
        ...prev,
        emailErr: !isValidEmail(value) ? "Please enter a valid Email" : "",
      }));
    }
    if (name === "password") {
      setErrors((prev) => ({
        ...prev,
        passErr: !validatePassword(value)
          ? "Password must be at least 4 characters"
          : "",
      }));
    }
  };

  const handleKey = (event) => {
    if (event.key == "Enter" && formState.password && formState.username) {
      login();
    }
  };
  const login = () => {
    const emailValid = isValidEmail(username);
    const passwordValid = validatePassword(password);

    if (!emailValid || !passwordValid) {
      setErrors({
        emailErr: !emailValid ? "Please enter a valid Email" : "",
        passErr: !passwordValid ? "Password must be at least 4 characters" : "",
      });
      return;
    }
    // if (username.toLowerCase().includes("company")) {

    // } else {
    //   navigate("/admin-list");
    // }

    let fdata = new FormData();
    fdata.append("email", username);
    fdata.append("password", password);

    setLoader(true);
    loginApi(fdata)
      .unwrap()
      .then((res) => {
        // console.log(
        //   "Login Successful",
        //   res?.permissions,
        //   res?.role == "Company Manager",
        //   res?.company?.name
        // );
        if (res?.status == "success") {
          const {
            permissions = [],
            role,
            company,
            message = "Login successful",
            token,
            user,
            type,
          } = res ?? {};

          // ---------- Local storage ----------
          if (company) {
            localStorage.setItem("company", JSON.stringify(company));
          }
          let user_data = {
            ...user,
            login_type: type,
            login_type_role: role,
            login_knf_typ: res?.knf_role,
          };
          localStorage.setItem("token", token);
          localStorage.setItem("user_details", JSON.stringify(user_data));
          localStorage.setItem("type", type);
          localStorage.setItem("user_permission", JSON.stringify(permissions));
          localStorage.setItem("loginData", JSON.stringify(res));
          // ---------- Decide the target screen ----------
          let screen = "";

          // if (permissions.includes("CAN-List-ADMINS")) {
          //   screen = "/admin-list";
          // }
          // else if (permissions.includes("CAN-List-ROLES")) {
          //   screen = "/role";
          // } else if (permissions.includes("CAN-List-USERS")) {
          //   screen = "/user-list";
          // } else if (permissions.includes("CAN-List-DEVICES")) {
          //   screen = "/device-list";
          // } else if (permissions.includes("CAN-List-LOCATIONS")) {
          //   screen = "/location-marks";
          // }
          // if (type === "admin" && company?.name) {
          //   screen = "/admin-list";
          // }
          if (type === "admin") {
            screen = "/admin-list";
          } else if (type === "Company Manager" && company?.name) {
            // Eg. “acme-corp/manager”
            screen = `/${company.name}/manager`;
          } else if (type === "Company Sub Admin" && company?.name) {
            screen = `/${company.name}/manager`;
          } else if (type === "Company User" && company?.name) {
            screen = `/${company.name}/manager`;
          } else if (
            type === "Unknown" &&
            user?.knf_role?.id &&
            !user?.knf_type
          ) {
            screen = `/admin-dashboard`;
          } else if (type === "Unknown" && user?.knf_type == 1) {
            screen = `/company-Dashboard`;
          } else if (type === "Unknown" && user?.knf_type == 2) {
            screen = `/site-Dashboard`;
          } else if (
            type === "Unknown" &&
            user?.knf_type >= 3 &&
            user?.knf_type <= 5
          ) {
            screen = `/group-dashboard`;
          }

          // ---------- Act on the result ----------
          if (!screen) {
            toast.info("No List Permissions");
          } else {
            navigate(screen);
            toast.success(message);
          }

          // let permission = res?.permissions;
          // const company = localStorage.setItem("company", JSON.stringify(res?.company));

          // let screen = permission?.includes("CAN-List-ADMINS")
          //   ? "/admin-list"
          //   : permission?.includes("CAN-List-ROLES")
          //     ? "/role"
          //     : permission?.includes("CAN-List-USERS")
          //       ? "/user-list"
          //       : permission?.includes("CAN-List-DEVICES")
          //         ? "/device-list"
          //         : permission?.includes("CAN-List-LOCATIONS")
          //           ? "/location-marks" : res?.role == "Company Manager"
          //             ?
          //             navigate(res?.company?.name + "/manager")

          //             : "No List Permissions";

          // if (screen == "No List Permissions") {
          //   toast.info(screen);
          // } else {
          //   navigate(screen);
          // }
          // toast.success(res?.message);
          // localStorage.setItem("token", res?.token);
          // localStorage.setItem("user_details", JSON.stringify(res?.admin));
          // localStorage.setItem(
          //   "user_permission",
          //   JSON.stringify(res?.permissions)
          // );
        } else {
          toast.error(res?.message);
          // console.log("check");
        }
      })
      .catch((err) => {
        console.error("Login Failed", err);
        toast.error(err?.data?.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };
  useEffect(() => {
    if (localStorage?.getItem("token")) {
      let company = JSON.parse(localStorage.getItem("company"));
      let user = JSON.parse(localStorage.getItem("user_details"));
      let type = localStorage.getItem("type");
      let screen = "";
      if (type === "admin") {
        screen = "/admin-list";
      } else if (type === "Company Manager" && company?.name) {
        // Eg. “acme-corp/manager”
        screen = `/${company.name}/manager`;
      } else if (type === "Company Sub Admin" && company?.name) {
        screen = `/${company.name}/manager`;
      } else if (type === "Company User" && company?.name) {
        screen = `/${company.name}/manager`;
      } else if (type === "Unknown" && user?.knf_role?.id && !user?.knf_type) {
        screen = `/admin-dashboard`;
      } else if (type === "Unknown" && user?.knf_type == 1) {
        screen = `/company-Dashboard`;
      } else if (type === "Unknown" && user?.knf_type == 2) {
        screen = `/site-Dashboard`;
      } else if (
        type === "Unknown" &&
        user?.knf_type >= 3 &&
        user?.knf_type <= 5
      ) {
        screen = `/group-dashboard`;
      }

      navigate(screen);
    }
  }, []);

  return (
    <div
      className="d-flex ac-jc w-100 vh-100 new_login_page"
      onKeyDown={handleKey}
    >
      <div className="main">
        <div className="login-right">
          <img
            // src={"https://knfepl.com/front_assets/img/KNF Logo.png"}
            src={knf_logo}
            className="logo"
            alt=""
          />
          <h2 className="mt-4 f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-26 fs-xxl-28 white">
            Welcome Back!!
          </h2>
          <div className="text-start">
            <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 white">
              Email
            </p>
            <div className="login-input mt-2">
              <MailOutlineRoundedIcon className="emial-icon" />
              <input
                type="email"
                name="username"
                placeholder="Email Address"
                autoComplete="off"
                value={username}
                onChange={handleInputChange}
              />
            </div>
            {emailErr && (
              <p className="err" style={{ color: "white", marginTop: "2%" }}>
                {emailErr}
              </p>
            )}
          </div>
          <div className="text-start">
            <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 white">
              Password
            </p>
            <div className="login-input mt-2">
              <LockOutlinedIcon className="emial-icon" />
              <input
                type={visible ? "text" : "password"}
                name="password"
                maxLength={20}
                className="cust-btn ps-2 w-90"
                placeholder="Password"
                autoComplete="off"
                value={password}
                onChange={handleInputChange}
              />
              {!visible && (
                <img
                  src={eye_icon}
                  onClick={() => setVisible(!visible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              )}
              {visible && (
                <div
                  onClick={() => setVisible(!visible)}
                  className="pointer sec"
                >
                  <VisibilityIcon className="eye-icon " />
                </div>
              )}
            </div>
            {passErr && (
              <p className="err" style={{ color: "white", marginTop: "2%" }}>
                {passErr}
              </p>
            )}
          </div>
          <div className="d-flex justify-content-end mt-1">
            <p
              onClick={() => navigate("/registration")}
              className="mt-1 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 white pointer"
            >
              Forgot Password?
            </p>
          </div>
          <button
            disabled={loader}
            onClick={() => login()}
            className="login-btn f2"
          >
            {loader ? (
              <div
                className="spinner-border spinner-border-sm"
                role="status"
                style={{ marginRight: "5px" }}
              ></div>
            ) : (
              "Login"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
